import { HttpErrorResponse } from "@angular/common/http";
import {
    Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild
} from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { AccountUserService } from "src/app/service/account.service";
import { Status } from "../../../../models/statusEnums";
import { ObjectEmailAuditService } from "../../api/api";
import {
    DraftedMail, EmailRecipient, ObjectEmailAudit
} from "../../model/models";
import { ActivityService } from "../shared-activities/activity.service";
import { TypeService } from "./api/api";
import { LionEmailComposeFormComponent } from "./email-compose-form/email-compose-form.component";
import {
    CategoryService,
    VendorOAuthRegistrationService, VendorOAuthRegistrationUserService, VendorService
} from "./Integration/api/api";
import {
    Vendor, VendorOAuthRegistration, VendorOAuthRegistrationUser
} from "./Integration/model/models";
import { Type } from "./model/models";
import { EmailAudit } from '../../model/models';
import { EmailAuditService } from 'src/app/shared/api/api';
import { NotificaitonEmailTemplateConfigModel } from "src/app/configurations/system/models/notification-email-template.model";
import { EmailTemplateService } from "src/app/configurations/system/services/email-template.service";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";
import { EmailTemplateNotificationTypesEnum } from "src/app/configurations/system/template/models/email-template-notification-types.enum";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { addInlineStyles } from "../../helpers/add-inline-styles.helper";
import { DomManipulationService } from "../../services/dom-manipulation.service";
import { PrepareEmailTemplateFields, PrepareEmailTemplateModel } from "../../models/send-emails/prepare-email-template.model";
import { customFieldTagRegex } from "../../constants/custom-field-tag.regex";
import { DomSanitizer } from "@angular/platform-browser";
import { checkValidTagsInText } from "../../validators/field-tags.validator";
import { AccountModuleId, LeadModuleId } from "../../constants/modules.constant";
import { FormErrorHandler } from "../../helpers/form-error-handler.helper";
import { emailValidator } from "../../validators/email.validator";
import { EmailService } from "./email.service";
import { SMTPConfiguration } from "./model/smtpConfiguration";

@Component({
    selector: "app-lion-shared-emails",
    templateUrl: "./shared-emails.component.html",
    styleUrls: ["./shared-emails.component.scss"],
    providers: [
        // AppMainService,
        VendorOAuthRegistrationUserService,
        VendorOAuthRegistrationService,
        CategoryService,
        TypeService,
        VendorService,
    ],
})
export class LionSharedEmailsComponent
    implements OnInit, OnChanges {
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    @Input() displaySendEmail;
    @Input() contacts;
    @Input() object;
    @Input() flag: string = '';
    @Input() thread;
    @Input() displayEmailSendOptions;
    @Input() emailAudit;
    @Input() channelId: number;
    @Input() objectId: number;
    @Input() objectTypeId: number;

    @Output() cancelEmail: EventEmitter<any> = new EventEmitter();
    @Output() cancelEmailSend: EventEmitter<any> = new EventEmitter();
    @Output() successEmailSend: EventEmitter<any> = new EventEmitter();
    @Output() syncSendEmail: EventEmitter<any> = new EventEmitter();

    @ViewChild("composeForm", { static: false })
    _composeForm: LionEmailComposeFormComponent;

    emailTemp: ObjectEmailAudit = {
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        objectId: 0,
        objectTypeId: 0,
        emailAuditId: 0,
        emailAudit: {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            createdDate: new Date(),
            vendorId: 0,
            organizationId: this.app.user.organizationId,
            messageId: "",
            conversationId: "",
            subject: "",
            statusId: Status.Active,
            isValid: true,
            validFromDate: null,
            validToDate: null,
            emailThreads: [
                {
                    id: 0,
                    createdSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    createdDate: new Date(),
                    emailAuditId: 0,
                    messageId: "",
                    conversationId: "",
                    subject: "",
                    messageData: "",
                    contentType: "html",
                    bodyPreview: "",
                    hasAttachment: false,
                    isDraft: false,
                    displayName: "",
                    userMail: "",
                    isRead: false,
                    receivedDateTime: null,
                    statusId: Status.Active,
                    isValid: true,
                    validFromDate: null,
                    validToDate: null,
                    emailRecipients: [
                        {
                            id: 0,
                            createdSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            createdDate: new Date(),
                            typeId: 0,
                            emailThreadId: 0,
                            emailAddress: "",
                            name: "",
                        },
                    ],
                    emailAttachments: [
                        {
                            id: 0,
                            createdSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            createdDate: new Date(),
                            emailThreadId: 0,
                            attachmentId: 0,
                            attachment: {
                                id: 0,
                                createdSource: this.app.userIP,
                                createdBy: this.app.user.userId,
                                createdDate: new Date(),
                                name: "",
                                guidName: "",
                                location: "",
                                content: "",
                                extension: "",
                                sizeInBytes: 0,
                                description: "",
                                statusId: Status.Active,
                                isValid: true,
                                validFromDate: null,
                                validToDate: null,
                            },
                        },
                    ],
                },
            ],
            scheduledDate: this.app._showDateTimeWithZone(new Date(new Date().getTime() + 60 * 60000))
        },
    };
    selectedOption = { name: "Send now", code: "sendnow" };
    options = [
        { name: "Send now", code: "sendnow" },
        { name: "Save as draft", code: "draft" },
        { name: "Schedule", code: "schedule" },
        // { name: "Save As Template", code: "saveastemplate" },
    ];
    mailClients = [];
    scheduledDate: Date = new Date();
    minimumDate: Date = new Date();
    loggedIn: boolean = false;
    emailRecipTypes: Type[] = [];
    displaySendEmailTemplate: any;
    displayConfigureEmail: any;
    windowRef = null;
    selectedIndex: number = 0;
    draftedEmails = [];
    draftedEmailsLength: number = 0;
    draftedEmailsLoading: boolean = false;
    scheduledEmails = [];
    scheduledEmailsLength: number = 0;
    scheduledEmailsLoading: boolean = false;
    emailTemplateName: string = null;
    emailTemplateNameValid: boolean = true;
    emailTemplateNameRequired: boolean = false;
    scheduledDateRequired: boolean = false;
    emailTemplateNameControl = new FormControl();
    savingSendMail: boolean = false;

    displayEmailPreview: boolean = false;
    emailPreviewResponse: { subject: string, content: string } = null;

    displaySMTPConfig = false;
    encryption = [
        { id: 1, name: "None" },
        { id: 2, name: "SSL/TLS" },
        { id: 3, name: "SSL/TLS" },
    ];
    selectedEncryption = this.encryption[0];
    incomingChecked = false;
    outgoingChecked = false;
    displayChangeUser = false;
    smtpSettingForm: FormGroup = new FormGroup({});
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    smtpConfigIndex = 1;

    constructor(
        private app: AppMainComponent,
        private objectEmailAuditService: ObjectEmailAuditService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private vendorUserService: VendorOAuthRegistrationUserService,
        private vendorRegistrationService: VendorOAuthRegistrationService,
        private vendorService: VendorService,
        private categoryService: CategoryService,
        private accountService: AccountUserService,
        public activityService: ActivityService,
        private emailAuditService: EmailAuditService,
        private emailTemplateService: EmailTemplateService,
        private confirmationService: ConfirmationService,
        private domManipulationService: DomManipulationService,
        public sanitizer: DomSanitizer,
        private formBuilder: FormBuilder,
        private emailService: EmailService
    ) { }

    ngOnInit() {
        this.initSMTPDetailsForm();
        this.validateEmailTemplateName();
        this.minimumDate = this.app._showDateTimeWithZone(new Date());
    }

    populateDraftCount() {
        if (this.app.configuredUser) {
            const options = {
                objectId: this.objectId,
                objectTypeId: this.objectTypeId,
                vendorId:
                    this.app.configuredUser?.vendorOAuthRegistration?.vendorId,
                userId: this.app.userId,
                clientIP: this.app.userIP,
            }
            this.setDraftedEmails(options, true);
            this.setSchudleEmails(options, true);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (let property in changes) {
            if (changes.displaySendEmail && changes.displaySendEmail.currentValue == true) {
                this.getAllCategory();
            }

            if (property === "displaySendEmail" || property === "loggedIn") {
                if (this.app.isConfigured) {
                    this.displaySendEmailTemplate = this.displaySendEmail;
                } else {
                    this.displayConfigureEmail = this.displaySendEmail;
                }

            }

            if (changes.contacts && changes.contacts.currentValue) {
                this.contacts = changes.contacts.currentValue;
            }

            if (changes.object && changes.object.currentValue) {
                this.object = changes.object.currentValue;
                if (this.app.configuredUser) {
                    // set drafted emails on selecting lead
                    if (
                        this.app.allObjects &&
                        this.app.hasOwnProperty("allObjects")
                    ) {
                        const options = {
                            objectId: this.objectId,
                            objectTypeId: this.objectTypeId,
                            vendorId:
                                this.app.configuredUser?.vendorOAuthRegistration?.vendorId,
                            userId: this.app.userId,
                            clientIP: this.app.userIP,
                        };
                        this.setDraftedEmails(options);
                        this.setSchudleEmails(options, true);
                    } else {
                        this.activityService
                            .getAllObjects()
                            .then((objects: any) => {
                                const allObjects = objects;
                                const options = {
                                    objectId: this.objectId,
                                    objectTypeId: allObjects.filter(
                                        (elem) =>
                                            elem.name === this.app.objectType
                                    )[0]?.id,
                                    vendorId:
                                        this.app.configuredUser?.vendorOAuthRegistration?.vendorId,
                                    userId: this.app.userId,
                                    clientIP: this.app.userIP,
                                };
                                this.setDraftedEmails(options);
                                this.setSchudleEmails(options, true);
                            });
                    }
                }
            }

        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    getAllCategory() {
        this.categoryService.getGroups()
            .subscribe((group: any) => {
                let categoryId = group.find(e => e.name == "MarketPlace").id;

                this.categoryService.getCategories(categoryId)
                    .subscribe((cate: any) => {
                        let emailId = cate.find(e => e.name == "Email").id;

                        this.vendorService
                            .lionO36020APIVendorGet(emailId)
                            .subscribe((vendorRes: any) => {
                                this.mailClients = vendorRes;
                                //this.mailClients = vendorRes.filter(client => client.name !== "Other SMTPs"); 
                            });
                    });

            })
    }

    setDraftedEmails(options, isDraftInitailCount: boolean = false) {
        const { objectId, objectTypeId, vendorId, userId, clientIP } = options;
        if (objectId) {
            !isDraftInitailCount && this.appMainService.isShowSpinner("setDraftedEmails");
            setTimeout(() => {
                this.draftedEmailsLoading = true;
                this.objectEmailAuditService
                    .lionO36020APIObjectEmailAuditDraftedMailGet(
                        objectId,
                        objectTypeId,
                        vendorId,
                        userId,
                        clientIP
                    )
                    .subscribe({
                        next: (res) => {
                            this.draftedEmails = res ?? [];
                            this.draftedEmailsLength = this.draftedEmails.length;
                            this.draftedEmailsLoading = false;
                            this.appMainService.isHideSpinner("setDraftedEmails");
                        },
                        error: (error) => {
                            this.draftedEmailsLoading = false;
                            this.appMainService.isHideSpinner("setDraftedEmails");
                        }
                    });
            }, isDraftInitailCount ? 0 : 0);
        }
    }

    setSchudleEmails(options: any, isSchudleInitailCount: boolean = false) {
        const { objectId, objectTypeId, vendorId, userId, clientIP } = options;
        if (objectId) {
            !isSchudleInitailCount && this.appMainService.isShowSpinner("setSchudleEmails");
            setTimeout(() => {
                this.scheduledEmailsLoading = true;
                this.objectEmailAuditService
                    .getAllScheduledEmail(
                        objectId,
                        objectTypeId,
                        vendorId
                    )
                    .subscribe({
                        next: (res) => {
                            this.scheduledEmails = res ?? [];
                            this.scheduledEmailsLength = this.scheduledEmails.length;
                            this.scheduledEmailsLoading = false;
                            this.appMainService.isHideSpinner("setSchudleEmails");
                        },
                        error: (error) => {
                            this.scheduledEmailsLoading = false;
                            this.appMainService.isHideSpinner("setSchudleEmails");
                        }
                    });
            }, isSchudleInitailCount ? 0 : 0);
        }
    }

    openInComposeEmail(emailObj) {
        this.emailTemp = {
            id: emailObj.id,
            objectId: emailObj.objectId,
            objectTypeId: emailObj.objectTypeId,
            createdSource: emailObj.createdSource,
            createdBy: emailObj.createdBy,
            createdDate: emailObj.createdDate,
            emailAuditId: emailObj.emailThreads[0].emailAuditId,
            emailAudit: {
                id: emailObj.emailThreads[0].emailAuditId,
                createdSource: emailObj.createdSource,
                createdBy: emailObj.createdBy,
                createdDate: emailObj.createdDate,
                vendorId: emailObj.vendorId,
                organizationId: emailObj.organizationId,
                messageId: emailObj.messageId,
                conversationId: emailObj.conversationId,
                subject: emailObj.subject,
                statusId: emailObj.statusId,
                isValid: emailObj.isValid,
                validFromDate: emailObj.validFromDate,
                validToDate: emailObj.validToDate,
                emailThreads: emailObj.emailThreads,
                isScheduled: emailObj?.isScheduled ?? false,
                scheduledDate: emailObj?.scheduledDate,
            },
        };
        this.selectedIndex = 0;
        this.selectedOption = { name: "Send now", code: "sendnow" };
    }

    handleChange(e) {
        this.selectedIndex = e.index;
        // to generalize logic
        const options = {
            objectId: e.objectId
                ? e.objectId
                : this.emailTemp.objectId
                    ? this.emailTemp.objectId
                    : this.objectId,
            objectTypeId: e.objectTypeId
                ? e.objectTypeId
                : this.emailTemp.objectTypeId
                    ? this.emailTemp.objectTypeId
                    : this.app.objectTypeId
                        ? this.app.objectTypeId : this.objectTypeId,
            vendorId: e.vendorId
                ? e.vendorId
                : this.emailTemp.emailAudit.vendorId
                    ? this.emailTemp.emailAudit.vendorId
                    : this.app.configuredUser?.vendorOAuthRegistration?.vendorId,
            userId: this.app.userId,
            clientIP: this.app.userIP,
        };
        switch (e.index) {
            case 0:
                //E-mail
                break;
            case 1:
                //Draft
                this.setDraftedEmails(options);
                break;
            case 2:
                //Scheduled
                this.setSchudleEmails(options);
                break;
            default:
                break;
        }
    }

    clearSendComposeForm() {
        if (this.displaySendEmailTemplate) {
            this._composeForm.toRecipients = [];
            this._composeForm.ccRecipients = [];
            this._composeForm.bccRecipients = [];
            this._composeForm.allRecipients =
                this._composeForm.allRecipientsDefaults;
        }
        if (this._composeForm && this._composeForm.emailForm) {
            this._composeForm.emailForm.reset();
        }

        this.selectedOption = { name: "Send now", code: "sendnow" };
        this.emailTemp = {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            createdDate: new Date(),
            objectId: 0,
            objectTypeId: 0,
            emailAuditId: 0,
            emailAudit: {
                id: 0,
                createdSource: this.app.userIP,
                createdBy: this.app.user.userId,
                createdDate: new Date(),
                vendorId: this.app.configuredUser?.vendorOAuthRegistration?.vendorId,
                organizationId: this.app.user.organizationId,
                messageId: "",
                conversationId: "",
                subject: "",
                statusId: Status.Active,
                isValid: true,
                validFromDate: null,
                validToDate: null,
                emailThreads: [
                    {
                        id: 0,
                        createdSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        createdDate: new Date(),
                        emailAuditId: 0,
                        messageId: "",
                        conversationId: "",
                        subject: null,
                        messageData: "",
                        contentType: "html",
                        bodyPreview: "",
                        hasAttachment: false,
                        isDraft: this.selectedOption.code === "draft",
                        displayName: "",
                        userMail: "",
                        isRead: false,
                        receivedDateTime: null,
                        statusId: Status.Active,
                        isValid: true,
                        validFromDate: null,
                        validToDate: null,
                        emailRecipients: [
                            {
                                id: 0,
                                createdSource: this.app.userIP,
                                createdBy: this.app.user.userId,
                                createdDate: new Date(),
                                typeId: 0,
                                emailThreadId: 0,
                                emailAddress: "",
                                name: "",
                            },
                        ],
                        emailAttachments: [
                            {
                                id: 0,
                                createdSource: this.app.userIP,
                                createdBy: this.app.user.userId,
                                createdDate: new Date(),
                                emailThreadId: 0,
                                attachmentId: 0,
                                attachment: {
                                    id: 0,
                                    createdSource: this.app.userIP,
                                    createdBy: this.app.user.userId,
                                    createdDate: new Date(),
                                    name: "",
                                    guidName: "",
                                    location: "",
                                    content: "",
                                    extension: "",
                                    sizeInBytes: 0,
                                    description: "",
                                    statusId: Status.Active,
                                    isValid: true,
                                    validFromDate: null,
                                    validToDate: null,
                                },
                            },
                        ],
                    },
                ],
                scheduledDate: this.app._showDateTimeWithZone(new Date(new Date().getTime() + 60 * 60000))
            },
        };
        this.savingSendMail = false;
        this.minimumDate = this.app._showDateTimeWithZone(new Date());

    }

    cancel() {
        this.clearSendComposeForm();
        this.displaySendEmailTemplate = false;
        this.displaySendEmail = false;
        this.displayEmailSendOptions = false;
        this.cancelEmail.emit({ cancelEmail: this.displaySendEmailTemplate });
        this.cancelEmailSend.emit({ cancelEmailSend: this.displaySendEmail });
        this.selectedIndex = 0;
        this.savingSendMail = false;
    }

    checkConfigurationAndPerformOps() {
        this.confirmationService.confirm({
            message: `Do you want to sign out from ${this.app.configuredUser.userMailId}?`,
            header: 'Email Sign Out',
            icon: 'pi pi-info-circle',
            accept: () => {
                if (this.app.configuredUser) {
                    if (this.app.isSMTP) {
                        this.app.configuredUser.isOtherSMTP = true;
                    } else {
                        this.app.configuredUser.isOtherSMTP = false;
                    }
                    this.app.configuredUser.statusId = Status.InActive;
                    this.app.configuredUser.updatedBy = this.app.companyId;
                    this.app.configuredUser.updatedSource = this.app.userIP;
                    this.app.configuredUser.updatedDate = new Date();
                    this.app.configuredUser.vendorOAuthRegistrationId = this.app.configuredUser.vendorOAuthRegistration.vendorId;
                    this.vendorUserService.lionO36020APIVendorOAuthRegistrationUserPut(this.app.configuredUser).toPromise().then((res: Response) => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email unconfigured successfully...' });
                        this.app.isConfigured = false;
                        this.app.configuredUserBSubject.next(false)
                        this.app.configuredUser = null;
                        this.cancel();
                    }, (err) => { this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.text }); });
                }
            },
            reject: () => { }
        });
    }

    configureEmail(client: Vendor) {
        this.vendorRegistrationService
            .lionO36020APIVendorOAuthRegistrationIdGet(client.id)
            .toPromise()
            .then((res: VendorOAuthRegistration) => {
                const loggedinUser = this.accountService.userValue;
                let userInfo = {
                    organizationId: loggedinUser.organizationId,
                    userId: loggedinUser.userId,
                    vendorId: res.vendorId,
                    clientIP: res.createdSource,
                    loginAuditId: loggedinUser.loginAuditId,
                    authToken: loggedinUser.token,
                    sessionId: localStorage.getItem("randomstr"),
                    sourceType: "Web"
                };
                let objEncStr = btoa(JSON.stringify(userInfo));
                let url = "";

                if (res.name === "MSGraph") {
                    url = `${res.registrationURL}client_id=${res.clientId}&redirect_uri=${res.redirectURL}&response_type=code&scope=openid+offline_access+profile+User.Read+Mail.Read+Mail.Send+Mail.ReadWrite+Group.ReadWrite.All+Directory.ReadWrite.All+Files.ReadWrite.All+Sites.ReadWrite.All+Tasks.ReadWrite+Calendars.ReadWrite&state=${objEncStr}`;
                } else if (res.name === "GmailAPI") {
                    url = `https://accounts.google.com/o/oauth2/auth?response_type=code&redirect_uri=${res.redirectURL}&state=${objEncStr}&access_type=offline&approval_prompt=force&scope=https://www.googleapis.com/auth/gmail.compose+https://www.googleapis.com/auth/gmail.readonly&client_id=${res.clientId}`;
                }
                this.windowRef = window.open(
                    url,
                    "child",
                    "toolbar=no,location=no,directories=no,status=no,menubar=no,titlebar=no,fullscreen=no,scrollbars=1,resizable=no,width=1000,height=650,left=200,top=100"
                );

                let windowRefInterval = setInterval(() => {
                    this.vendorUserService
                        .lionO36020APIVendorOAuthRegistrationUserUserIdGet()
                        .toPromise()
                        .then((res: VendorOAuthRegistrationUser) => {
                            if (res) {
                                this.app.isConfigured = res.statusId !== 2;
                                this.app.configuredUser =
                                    res.statusId !== 2 ? res : null;
                                this.displayConfigureEmail = false;
                                this.app.configuredUserBSubject.next(this.app.isConfigured)

                                this.app.getAllObjects();
                                //this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
                                if (this.windowRef) {
                                    this.windowRef.close();
                                }
                                clearInterval(windowRefInterval);
                            }
                        });
                }, 500);
            });
    }

    configureSMTP(client) {
        this.smtpConfigIndex = 1;
        this.displaySMTPConfig = true;

    }
    changeUser() {
        this.displayChangeUser = true;
    }

    sendMailFromActivity() {
        if (this._composeForm.emailForm.form.valid) {
            this.appMainService.isShowSpinner('threadMail');
            let eachRecipient: EmailRecipient = {
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "typeId": 0,
                "emailThreadId": 0,
                "emailAddress": "",
                "name": ""
            }

            this.emailAudit = this.app.copyObjectWithoutRefrence(this._composeForm.emailAudit);

            if (this._composeForm.toRecipients.length > 0) {
                for (let recipient of this._composeForm.toRecipients) {
                    eachRecipient.emailAddress = recipient.emailAddress;
                    eachRecipient.name = recipient.name;
                    eachRecipient.emailThreadId = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].id;
                    eachRecipient.typeId = this.app.emailRecipTypes.filter(elem => elem.name === "To")[0].id;
                    this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].emailRecipients.push(this.app.copyObjectWithoutRefrence(eachRecipient));
                }
            }

            if (this._composeForm.showCc && this._composeForm.ccRecipients.length > 0) {
                for (let recipient of this._composeForm.ccRecipients) {
                    eachRecipient.emailAddress = recipient.emailAddress;
                    eachRecipient.name = recipient.name;
                    eachRecipient.typeId = this.app.emailRecipTypes.filter(elem => elem.name === "CC")[0].id;
                    eachRecipient.emailThreadId = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].id;
                    this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].emailRecipients.push(this.app.copyObjectWithoutRefrence(eachRecipient));
                }
            }

            if (this._composeForm.showBcc && this._composeForm.bccRecipients.length > 0) {
                for (let recipient of this._composeForm.bccRecipients) {
                    eachRecipient.emailAddress = recipient.emailAddress;
                    eachRecipient.name = recipient.name;
                    eachRecipient.typeId = this.app.emailRecipTypes.filter(elem => elem.name === "BCC")[0].id;
                    eachRecipient.emailThreadId = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].id;
                    this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].emailRecipients.push(this.app.copyObjectWithoutRefrence(eachRecipient));
                }
            }


            if (this.flag === 'S' || this.flag === 'A') {
                if (this._composeForm.emailAttachments.length > 0) {
                    this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].emailAttachments = this._composeForm.emailAttachments;
                    this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].hasAttachment = true;
                } else {
                    this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].emailAttachments = null;
                    this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].hasAttachment = false;
                }
            }

            this.emailAudit.updatedBy = this.app.user.userId;
            this.emailAudit.updatedSource = this.app.userIP;
            this.emailAudit.updatedDate = new Date();
            this.emailAudit.status = null;
            this.emailAudit.vendor = null;
            let emailAuditTemp: EmailAudit = this.app.copyObjectWithoutRefrence(this.emailAudit);
            emailAuditTemp.emailThreads = emailAuditTemp.emailThreads.filter(el => el.id === 0);
            emailAuditTemp.emailThreads[0].status = null;
            for (let recip of emailAuditTemp.emailThreads[0].emailRecipients) {
                recip.type = null;
            }

            if (this.flag === 'F') {
                if (this._composeForm.emailAttachments.length > 0) {
                    this.emailAudit.emailThreads[0].emailAttachments = this._composeForm.emailAttachments;
                    this.emailAudit.emailThreads[0].hasAttachment = true;
                } else {
                    this.emailAudit.emailThreads[0].emailAttachments = null;
                    this.emailAudit.emailThreads[0].hasAttachment = false;
                }
            }
            if (emailAuditTemp) {
                let messageData: any = emailAuditTemp?.emailThreads[0]?.messageData ?? "";
                messageData = this.domManipulationService.replacePWithDiv(messageData);
                emailAuditTemp.emailThreads[0].messageData = addInlineStyles(messageData);
            }
            if (this.flag === 'S' || this.flag === 'A') {
                this.emailAuditService.lionO36020APIEmailAuditReplyMailPost(emailAuditTemp).subscribe((res: EmailAudit) => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reply sent successfully...' });
                    this.appMainService.isHideSpinner('threadMail');
                    this.cancel();
                    // this.app.getAllObjects();
                    this.sendMailAutoSync({ emailAuditId: res?.id }, { emailAudit: res });
                    this.clearSendComposeForm();
                    this.successEmailSend.emit();
                    //this.isActionStarted = false;
                }, (err) => {
                    this.appMainService.isHideSpinner('threadMail');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.text });
                });
            } else if (this.flag === 'F') {
                this.emailAuditService.lionO36020APIEmailAuditForwardMailPost(emailAuditTemp).subscribe((res: EmailAudit) => {
                    this.appMainService.isHideSpinner('threadMail');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Message forwarded successfully...' });
                    this.cancel();
                    this.app.getAllObjects();
                    this.clearSendComposeForm();
                    this.successEmailSend.emit();
                    //this.isActionStarted = false;
                }, (err) => {
                    this.appMainService.isHideSpinner('threadMail');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.text });
                });
            }
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please fill out required information..." });
        }
    }

    sendMail(code: any) {
        if (this.selectedOption.code === "schedule" && !this.emailTemp?.emailAudit?.scheduledDate) {
            this.scheduledDateRequired = true;
            return;
        }
        this.savingSendMail = true;
        // save email in draft
        if (code === "draft") {
            this.appMainService.isShowSpinner("Mail");
            let eachRecipient: EmailRecipient = {
                id: 0,
                createdSource: this.app.userIP,
                createdBy: this.app.user.userId,
                createdDate: new Date(),
                typeId: 0,
                emailThreadId: 0,
                emailAddress: "",
                name: "",
            };
            this.emailTemp.emailAudit = this.app.copyObjectWithoutRefrence(
                this._composeForm.emailAudit
            );
            this.emailTemp.emailAudit.vendorId =
                this.app.configuredUser?.vendorOAuthRegistration?.vendorId;
            this.emailTemp.objectId = this.objectId;
            this.emailTemp.objectTypeId = this.objectTypeId;

            this.emailTemp.emailAudit.emailThreads[0].emailRecipients = [];
            if (this._composeForm.toRecipients.length > 0) {
                for (let recipient of this._composeForm.toRecipients) {
                    eachRecipient.emailAddress = recipient.emailAddress;
                    eachRecipient.name = recipient.name;
                    eachRecipient.typeId = this.app.emailRecipTypes.filter(
                        (elem) => elem.name === "To"
                    )[0].id;
                    this.emailTemp.emailAudit.emailThreads[0].emailRecipients.push(
                        this.app.copyObjectWithoutRefrence(eachRecipient)
                    );
                }
            }

            if (
                this._composeForm.showCc &&
                this._composeForm.ccRecipients.length > 0
            ) {
                for (let recipient of this._composeForm.ccRecipients) {
                    eachRecipient.emailAddress = recipient.emailAddress;
                    eachRecipient.name = recipient.name;
                    eachRecipient.typeId = this.app.emailRecipTypes.filter(
                        (elem) => elem.name === "CC"
                    )[0].id;
                    this.emailTemp.emailAudit.emailThreads[0].emailRecipients.push(
                        this.app.copyObjectWithoutRefrence(eachRecipient)
                    );
                }
            }

            if (
                this._composeForm.showBcc &&
                this._composeForm.bccRecipients.length > 0
            ) {
                for (let recipient of this._composeForm.bccRecipients) {
                    eachRecipient.emailAddress = recipient.emailAddress;
                    eachRecipient.name = recipient.name;
                    eachRecipient.typeId = this.app.emailRecipTypes.filter(
                        (elem) => elem.name === "BCC"
                    )[0].id;
                    this.emailTemp.emailAudit.emailThreads[0].emailRecipients.push(
                        this.app.copyObjectWithoutRefrence(eachRecipient)
                    );
                }
            }
            this.emailTemp.emailAudit.emailThreads[0].subject =
                this.emailTemp.emailAudit.subject;
            this.emailTemp.emailAudit.emailThreads[0].isDraft =
                this.selectedOption.code === "draft";
            this.emailTemp.emailAudit.emailThreads[0].isRead = false;
            this.emailTemp.emailAudit.emailThreads[0].displayName =
                this.app.configuredUser.displayName;
            this.emailTemp.emailAudit.emailThreads[0].userMail =
                this.app.configuredUser.userMailId;
            if (this._composeForm.emailAttachments.length > 0) {
                this.emailTemp.emailAudit.emailThreads[0].emailAttachments =
                    this._composeForm.emailAttachments;
                this.emailTemp.emailAudit.emailThreads[0].hasAttachment = true;
            } else {
                this.emailTemp.emailAudit.emailThreads[0].emailAttachments =
                    null;
                this.emailTemp.emailAudit.emailThreads[0].hasAttachment = false;
            }
            let emailTempObj: ObjectEmailAudit = null;
            if (this.emailTemp) {
                emailTempObj = JSON.parse(JSON.stringify(this.emailTemp));
                let messageData: any = emailTempObj.emailAudit.emailThreads[0].messageData ?? "";
                messageData = this.domManipulationService.replacePWithDiv(messageData);
                emailTempObj.emailAudit.emailThreads[0].messageData = addInlineStyles(messageData);
            }
            this.objectEmailAuditService
                .lionO36020APIObjectEmailAuditDraftMailPost(emailTempObj)
                .subscribe(
                    (res) => {
                        this.appMainService.isHideSpinner("Mail");
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Save to Draft successfully...",
                        });
                        //this.cancel();
                        //this.app.getAllObjects();
                        // this.selectedIndex = 1
                        this.savingSendMail = false;
                        this.handleChange({
                            index: 1,
                            objectId: this.emailTemp.objectId,
                            objectTypeId: this.emailTemp.objectTypeId,
                            vendorId: this.emailTemp.emailAudit.vendorId,
                        });
                        this.clearSendComposeForm();
                    },
                    (err: HttpErrorResponse) => {

                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Failed To Save As Draft",

                        });
                        this.savingSendMail = false;
                    }
                );
            this.appMainService.isHideSpinner("Mail");
        } else if (this._composeForm.emailForm.form.valid) {
            // for drafted email
            if (this.emailTemp.emailAudit.emailThreads[0].isDraft) {
                const data: DraftedMail = {
                    id: this.emailTemp.id,
                    createdSource: this.emailTemp.createdSource,
                    updatedSource: this.emailTemp.updatedSource,
                    createdBy: this.emailTemp.createdBy,
                    updatedBy: this.app.user.userId,
                    createdDate: this.emailTemp.createdDate,
                    updatedDate: new Date(),
                    vendorId: this.emailTemp.emailAudit.vendorId,
                    organizationId: this.emailTemp.emailAudit.organizationId,
                    messageId: this.emailTemp.emailAudit.messageId,
                    conversationId: this.emailTemp.emailAudit.conversationId,
                    subject: this.emailTemp.emailAudit.subject,
                    statusId: this.emailTemp.emailAudit.statusId,
                    isValid: this.emailTemp.emailAudit.isValid,
                    validFromDate: this.emailTemp.emailAudit.validFromDate,
                    validToDate: this.emailTemp.emailAudit.validToDate,
                    emailThreads: this.emailTemp.emailAudit.emailThreads,
                };
                const emailTempObj = JSON.parse(JSON.stringify(this.emailTemp));
                if (this.emailTemp) {
                    let messageData: any = emailTempObj.emailAudit.emailThreads[0].messageData ?? "";
                    messageData = this.domManipulationService.replacePWithDiv(messageData);
                    emailTempObj.emailAudit.emailThreads[0].messageData = addInlineStyles(messageData);
                    data.emailThreads = emailTempObj.emailAudit.emailThreads;
                }

                let emailTemplate: PrepareEmailTemplateModel = null

                if ([AccountModuleId, LeadModuleId]) {
                    let templateAttachments = this._composeForm?.emailTemplateAttachments || [];
                    templateAttachments = templateAttachments.filter(attachment => attachment?.attachment && attachment?.attachment?.statusId != Status.Deleted);
                    emailTemplate = {
                        objectId: this.objectTypeId,
                        objectRecordId: this.objectId,
                        subject: data.subject,
                        body: emailTempObj.emailAudit.emailThreads[0].messageData,
                        emailTemplateFields: [],
                        emailAttachments: templateAttachments
                    }
                    emailTemplate.emailTemplateFields = this.emailTemplateFields(emailTemplate.body, emailTemplate.subject);
                    const validTags = this.checkValidTags(emailTemplate.subject, emailTemplate.body);

                    if (!validTags) { //return body have any invalid tags
                        this.appMainService.isHideSpinner("Mail");
                        this.savingSendMail = false;
                        return;
                    }
                }

                this.objectEmailAuditService
                    .lionO36020APIObjectEmailAuditSendDraftedMail(data, emailTemplate)
                    .subscribe(
                        (res) => {
                            this.appMainService.isHideSpinner("Mail");
                            this.messageService.add({
                                severity: "success",
                                summary: "Success",
                                detail: "Email sent successfully...",
                            });
                            this.sendMailAutoSync({ emailAuditId: res?.id }, data);
                            this.cancel();
                            //this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
                            // this.app.getAllObjects();
                            this.clearSendComposeForm();
                        },
                        (err: HttpErrorResponse) => {
                            this.messageService.add({
                                severity: "error",
                                summary: "Error",
                                detail: err.error,
                            });
                            this.savingSendMail = false;
                        }
                    );
            } else {

                // for new email
                this.appMainService.isShowSpinner("Mail");
                let eachRecipient: EmailRecipient = {
                    id: 0,
                    createdSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    createdDate: new Date(),
                    typeId: 0,
                    emailThreadId: 0,
                    emailAddress: "",
                    name: "",
                };

                this.emailTemp.emailAudit = this.app.copyObjectWithoutRefrence(
                    this._composeForm.emailAudit
                );
                this.emailTemp.emailAudit.vendorId =
                    this.app.configuredUser?.vendorOAuthRegistration?.vendorId;
                this.emailTemp.objectId = this.objectId;
                this.emailTemp.objectTypeId = this.objectTypeId;
                if (this.flag != '') {
                    this.emailTemp.emailAudit.emailThreads[0].messageData = this._composeForm.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].messageData;
                }
                this.emailTemp.emailAudit.emailThreads[0].emailRecipients = [];
                if (this._composeForm.toRecipients.length > 0) {
                    for (let recipient of this._composeForm.toRecipients) {
                        eachRecipient.emailAddress = recipient.emailAddress;
                        eachRecipient.name = recipient.name;
                        eachRecipient.typeId = this.app.emailRecipTypes.filter(
                            (elem) => elem.name === "To"
                        )[0].id;
                        this.emailTemp.emailAudit.emailThreads[0].emailRecipients.push(
                            this.app.copyObjectWithoutRefrence(eachRecipient)
                        );
                    }
                }

                if (
                    this._composeForm.showCc &&
                    this._composeForm.ccRecipients.length > 0
                ) {
                    for (let recipient of this._composeForm.ccRecipients) {
                        eachRecipient.emailAddress = recipient.emailAddress;
                        eachRecipient.name = recipient.name;
                        eachRecipient.typeId = this.app.emailRecipTypes.filter(
                            (elem) => elem.name === "CC"
                        )[0].id;
                        this.emailTemp.emailAudit.emailThreads[0].emailRecipients.push(
                            this.app.copyObjectWithoutRefrence(eachRecipient)
                        );
                    }
                }

                if (
                    this._composeForm.showBcc &&
                    this._composeForm.bccRecipients.length > 0
                ) {
                    for (let recipient of this._composeForm.bccRecipients) {
                        eachRecipient.emailAddress = recipient.emailAddress;
                        eachRecipient.name = recipient.name;
                        eachRecipient.typeId = this.app.emailRecipTypes.filter(
                            (elem) => elem.name === "BCC"
                        )[0].id;
                        this.emailTemp.emailAudit.emailThreads[0].emailRecipients.push(
                            this.app.copyObjectWithoutRefrence(eachRecipient)
                        );
                    }
                }
                // this.emailTemp.emailAudit.isScheduled = this.emailTemp.emailAudit.isScheduled ?? this.selectedOption.code === "schedule";
                this.emailTemp.emailAudit.isScheduled = this.selectedOption.code === "schedule";
                this.emailTemp.emailAudit.scheduledDate = this.selectedOption.code === "schedule" && this.emailTemp.emailAudit?.scheduledDate ? this.app._saveDateTimeWithZone(new Date(this.emailTemp.emailAudit?.scheduledDate)) : null;
                this.emailTemp.emailAudit.emailThreads[0].subject =
                    this.emailTemp.emailAudit.subject;
                this.emailTemp.emailAudit.emailThreads[0].isDraft =
                    this.selectedOption.code === "draft";
                this.emailTemp.emailAudit.emailThreads[0].isRead = false;
                this.emailTemp.emailAudit.emailThreads[0].displayName =
                    this.app.configuredUser.displayName;
                this.emailTemp.emailAudit.emailThreads[0].userMail =
                    this.app.configuredUser.userMailId;
                if (this._composeForm.emailAttachments.length > 0) {
                    this.emailTemp.emailAudit.emailThreads[0].emailAttachments =
                        this._composeForm.emailAttachments;
                    this.emailTemp.emailAudit.emailThreads[0].hasAttachment =
                        true;
                } else {
                    this.emailTemp.emailAudit.emailThreads[0].emailAttachments =
                        null;
                    this.emailTemp.emailAudit.emailThreads[0].hasAttachment =
                        false;
                }
                let emailTempObj: ObjectEmailAudit = null;
                if (this.emailTemp) {
                    emailTempObj = JSON.parse(JSON.stringify(this.emailTemp));
                    let messageData: any = emailTempObj.emailAudit.emailThreads[0].messageData ?? "";
                    messageData = this.domManipulationService.replacePWithDiv(messageData);
                    emailTempObj.emailAudit.emailThreads[0].messageData = addInlineStyles(messageData);
                }

                let emailTemplate: PrepareEmailTemplateModel = null

                if ([AccountModuleId, LeadModuleId ]) {
                    let templateAttachments = this._composeForm?.emailTemplateAttachments || [];
                    templateAttachments = templateAttachments.filter(attachment => attachment?.attachment && attachment?.attachment?.statusId != Status.Deleted);
                    emailTemplate = {
                        objectId: this.objectTypeId,
                        objectRecordId: this.objectId,
                        subject: emailTempObj.emailAudit.emailThreads[0].subject,
                        body: emailTempObj.emailAudit.emailThreads[0].messageData,
                        emailTemplateFields: [],
                        emailAttachments: templateAttachments
                    }
                    emailTemplate.emailTemplateFields = this.emailTemplateFields(emailTemplate.body, emailTemplate.subject);
                    const validTags = this.checkValidTags(emailTemplate.subject, emailTemplate.body);

                    if (!validTags) { //return body have any invalid tags
                        this.appMainService.isHideSpinner("Mail");
                        this.savingSendMail = false;
                        return;
                    }
                }

                this.objectEmailAuditService
                    .lionO36020APIObjectEmailAuditSendMailPost(emailTempObj, emailTemplate)
                    .subscribe(
                        (res) => {
                            const successMsg = this.emailTemp.emailAudit?.isScheduled ? 'Scheduled Email saved successfully...' : 'Email sent successfully...';
                            this.appMainService.isHideSpinner("Mail");
                            this.messageService.add({
                                severity: "success",
                                summary: "Success",
                                detail: successMsg,
                            });
                            //this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
                            // this.app.getAllObjects();
                            if (!this.emailTemp?.emailAudit?.isScheduled) {
                                this.sendMailAutoSync(res?.objectEmailAudit, this.emailTemp);
                                this.cancel();
                            }
                            else {
                                this.handleChange({
                                    index: 2,
                                    objectId: this.emailTemp.objectId,
                                    objectTypeId: this.emailTemp.objectTypeId,
                                    vendorId: this.emailTemp.emailAudit.vendorId,
                                });

                            }
                            this.clearSendComposeForm();
                        },
                        (err: HttpErrorResponse) => {
                            this.messageService.add({
                                severity: "error",
                                summary: "Error",
                                detail: err.error.Message,
                            });
                            this.savingSendMail = false;
                        }
                    );
            }
            this.appMainService.isHideSpinner("Mail");
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please fill out required information...",
            });
            this.savingSendMail = false;
        }
    }

    checkValidTags(subject: string, body: string) {

        if (this._composeForm?.availableFields?.length > 0) {
            const validBodyTags = checkValidTagsInText(this._composeForm.availableFields, body).valid;
            if (!validBodyTags) {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Email body have some invalid tags, please remove invalid tags and try again...",
                });
            }

            const validSubjectTags = checkValidTagsInText(this._composeForm.availableFields, subject).valid;
            if (!validSubjectTags) {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Email subject have some invalid tags, please remove invalid tags and try again...",
                });
            }

            return (validBodyTags && validSubjectTags);
        }

        return true;
    }

    openEmailTemplatePreview() {
        const emailAudit: EmailAudit = this._composeForm.emailAudit;

        const emailTemplate: PrepareEmailTemplateModel = {
            objectId: this.objectTypeId,
            objectRecordId: this.objectId,
            subject: emailAudit.subject,
            body: emailAudit.emailThreads[emailAudit.emailThreads.length > 1 ? emailAudit.emailThreads.length - 1 : 0]?.messageData ?? '',
            emailTemplateFields: [],
            emailAttachments: []
        }

        const messageData = this.domManipulationService.replacePWithDiv(emailTemplate.body);
        emailTemplate.body = addInlineStyles(messageData);

        emailTemplate.emailTemplateFields = this.emailTemplateFields(emailTemplate.body, emailTemplate.subject);

        const validTags = this.checkValidTags(emailTemplate.subject, emailTemplate.body);
        if (!validTags) return;

        if (emailTemplate.emailTemplateFields?.length > 0) {
            this.appMainService.isShowSpinner("emailTemplatePreview");
            this.objectEmailAuditService.emailPreview(emailTemplate, this.objectId).subscribe({
                next: (response) => {
                    this.displayEmailPreview = true;
                    this.emailPreviewResponse = response;
                    this.appMainService.isHideSpinner("emailTemplatePreview");
                },
                error: (error) => {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.Message
                    });
                    this.appMainService.isHideSpinner("emailTemplatePreview");
                }
            })
        } else {
            this.displayEmailPreview = true;
            this.emailPreviewResponse = {
                subject: emailTemplate.subject,
                content: emailTemplate.body
            };
        }


    }

    closePreview() {
        this.displayEmailPreview = false;
    }

    emailTemplateFields(messageBody: string, messageSubject: string) {
        const fieldTypes = this._composeForm.fieldTypes;
        const addedFieldTags: string[] = [];
        const emailTemplateFields: PrepareEmailTemplateFields[] = [];
        const value = messageBody + messageSubject;
        if (value) {
            const addedTags: string[] = value.match(customFieldTagRegex) || [];

            addedTags.map(labelName => {
                const exist = fieldTypes.find(field => field.name.trim() == labelName.trim());

                if (exist) {
                    if (!addedFieldTags.includes(exist.name))
                        addedFieldTags.push(exist.name);
                }
            })
        }

        addedFieldTags.map(labelName => {
            const exist = fieldTypes.find(field => field.name == labelName);
            if (exist) {
                emailTemplateFields.push({
                    id: 0,
                    fieldName: exist.field,
                    columnSettingId: exist.id,
                    templateFieldName: exist.name.trim(),
                    isCustom: exist.custom,
                    statusId: 1
                })
            }
        })

        return emailTemplateFields;
    }

    scheduledDateCheck() {
        this.scheduledDateRequired = this.selectedOption.code === "schedule" && !this.emailTemp?.emailAudit?.scheduledDate ? true : false;
        this.savingSendMail = false;
    }

    async saveAsEmailTemplate() {
        const emailAudit: EmailAudit = this._composeForm.emailAudit;
        await this.getEmailTemplateValidation();
        if (!(this.emailTemplateName?.trim()?.length > 0)) {
            this.emailTemplateNameRequired = true;
            return;
        }
        if (this.emailTemplateNameValid == false) {
            return;
        }
        if (!emailAudit.subject) {
            this.messageService.add({
                severity: "warn",
                summary: "Error",
                detail: "Subject is required...",
            });
            return;
        }


        const templateData: NotificaitonEmailTemplateConfigModel = {
            id: 0,
            organizationId: 0,
            objectId: this.objectTypeId,
            channelId: this.channelId,
            channelName: 'Default Channel',
            templateName: this.emailTemplateName ?? '',
            templateSubject: emailAudit.subject,
            templateBody: emailAudit.emailThreads[emailAudit.emailThreads.length > 1 ? emailAudit.emailThreads.length - 1 : 0]?.messageData ?? '',
            messageContent: '',
            notificationType: EmailTemplateNotificationTypesEnum.Email,
            actionType: 0,
            isHtmlBody: true,
            isDefault: false,
            isEditable: true,
            isEnclosureRequired: false,
            statusId: Status.Active,
            notificationTemplateFields: [],
            notificationTemplateAttachments: []
        }

        this.appMainService.isShowSpinner('saveAsEmailTemplate');
        this.emailTemplateService.addEmailTemplate(templateData).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('saveAsEmailTemplate');
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email Template Added!' });
            },
            error: (error) => {
                this.appMainService.isHideSpinner('saveAsEmailTemplate');
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add Email Template Information!' });
            }
        });
    }

    validateEmailTemplateName() {
        this.emailTemplateNameControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe(value => {
                this.emailTemplateName = value?.trim() ?? '';
                if (this.emailTemplateName) {
                    this.emailTemplateService.validateEmailTemplate(this.emailTemplateName, 1).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                        next: (response) => {
                            this.emailTemplateNameValid = !response ? true : false;
                        },
                        error: (error) => {

                        }
                    });
                }
                else {
                    this.emailTemplateNameValid = true;
                }
            });
    }

    async getEmailTemplateValidation() {
        if (this.emailTemplateName) {
            this.emailTemplateService.validateEmailTemplate(this.emailTemplateName, 1).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.emailTemplateNameValid = !response ? true : false;
                },
                error: (error) => {

                }
            });
        }
        else {
            this.emailTemplateNameValid = true;
        }
    }

    deleteMail(emailObj: any, type: 'draft' | 'schedule') {
        this.confirmationService.confirm({
            message: `Do you want to delete this ${type} Mail?`,
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            // key: 'confirm-delete-draft-schedule-mail22',
            accept: () => {
                this.objectEmailAuditService.deleteMail(emailObj.id).subscribe({
                    next: (res) => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                        this.handleChange({
                            index: this.selectedIndex,
                            objectId: this.emailTemp.objectId,
                            objectTypeId: this.emailTemp.objectTypeId,
                            vendorId: this.emailTemp.emailAudit.vendorId,
                        });
                    },
                    error: (err: any) => {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
                    }
                });
            },
            reject: () => {
            }
        });
    }

    sendMailAutoSync(res: any, data: any) {
        if (res && data) {
            res.emailRecipients = data?.emailAudit?.emailThreads?.[0]?.emailRecipients?.[0]?.emailAddress ?? '';
            res.sender = data?.emailAudit?.emailThreads?.[0]?.userMail ?? '';
            res.messageData = data?.emailAudit?.emailThreads?.[0]?.messageData ?? '';
            res.direction = "Sent";
        }
        this.syncSendEmail.emit(res);
    }

    //#regionIMAPSettingForm
    initSMTPDetailsForm() {
        this.detailsFormErrors = {};
        this.smtpSettingForm = this.formBuilder.group({
            // Incoming mail settings
            incomingServer: [null, Validators.required],
            incomingPort: [null, Validators.required],
            incomingEmail: [null, [Validators.required, emailValidator]],
            incomingPassword: [null, Validators.required],

            // Outgoing mail settings
            outgoingServer: [null, Validators.required],
            outgoingPort: [null, Validators.required],
            outgoingEmail: [null, [Validators.required, emailValidator]],
            outgoingPassword: [null, Validators.required]
        });

        this.formErrorHandler.handleErrors(this.smtpSettingForm, this.detailsFormErrors, {
            incomingServer: {
                required: 'Server is required'
            },
            incomingPort: {
                required: 'Port is required'

            },
            incomingEmail: {
                required: "Email is required",
                valid: "Enter a valid Email Address"
            },
            incomingPassword: {
                required: "Password is required",
            },
            outgoingServer: {
                required: 'Server is required'
            },
            outgoingPort: {
                required: 'Port is required'

            },
            outgoingEmail: {
                required: "Email is required",
                valid: "Enter a valid Email Address"
            },
            outgoingPassword: {
                required: "Password is required",
            }
        });
    }

    saveSmtpConfig() {
        if (this.smtpSettingForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        const SmtpConfig = this.prepareSMTPConfiguration();
        if (SmtpConfig) {
            this.emailService.SetSMTPConfiguration(SmtpConfig).subscribe({
                next: (response) => {
                    this.onCancelSmtpPopup();
                    this.appMainService.isHideSpinner('SaveNewTask');
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'SMTP Configured Successfully'
                    });

                    this.emailService.getSMTPData()
                        .toPromise()
                        .then((res: VendorOAuthRegistrationUser) => {
                            if (res) {
                                this.app.isConfigured = res.statusId !== 2;
                                this.app.configuredUser =
                                    res.statusId !== 2 ? res : null;
                                this.displayConfigureEmail = false;
                                this.app.configuredUserBSubject.next(this.app.isConfigured);
                                this.app.getAllObjects();
                            }
                        });
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('SaveNewTask');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Failed To Configured SMTP'
                    });
                }
            })
        }

    }

    //prepare Payload
    prepareSMTPConfiguration(): SMTPConfiguration {
        const formData = this.smtpSettingForm.getRawValue();
        const configuration: SMTPConfiguration = {
            incomingServer: formData.incomingServer,
            incomingEmail: formData.incomingEmail,
            incomingPassword: formData.incomingPassword,
            incomingPort: formData.incomingPort,
            outgoingServer: formData.outgoingServer,
            outgoingEmail: formData.outgoingEmail,
            outgoingPassword: formData.outgoingPassword,
            outgoingPort: formData.outgoingPort
        };

        return configuration;
    }
    onCancelSmtpPopup() {
        this.smtpSettingForm.reset();
        this.smtpConfigIndex = 1;
        this.displaySMTPConfig = false;
    }


    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);
        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }
    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    verifySmtp() {
        const SmtpConfig = this.prepareSMTPConfiguration();
        if (SmtpConfig) {
            this.emailService.verifySMTPConfiguration(SmtpConfig).subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('SaveNewTask');
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'SMTP Information Verified'
                    });
                    this.smtpConfigIndex = 2;
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('SaveNewTask');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Invalid Information to configure SMTP'
                    });
                }
            })
        }
    }
}
